import { render, staticRenderFns } from "./OrderCalculatorRoto.vue?vue&type=template&id=3843a346&scoped=true&"
import script from "./OrderCalculatorRoto.vue?vue&type=script&lang=js&"
export * from "./OrderCalculatorRoto.vue?vue&type=script&lang=js&"
import style0 from "./OrderCalculatorRoto.vue?vue&type=style&index=0&id=3843a346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3843a346",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VCard,VCardText,VSheet,VWindow,VWindowItem})
